import { Link } from 'react-router-dom';

interface Props {
  kicker: string;
  title: string;
  desc?: string;
  link?: { to: string; label: string };
}

export default function SectionHead({ kicker, title, desc, link }: Props) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div>
        <p className="flex items-center gap-2 text-xs font-black tracking-[0.2em] text-accent-600">
          <span className="inline-block h-px w-6 bg-accent-500"></span>
          {kicker}
        </p>
        <h2 className="mt-2 font-heading text-2xl font-black text-foreground-900 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-600">{desc}</p>}
      </div>
      {link && (
        <Link
          to={link.to}
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-700 hover:text-primary-800 sm:flex"
        >
          {link.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}